module.exports = __webpack_public_path__ + "static/media/005ty@4x.e5b7c6a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/005ty@4x.png
// module id = 412
// module chunks = 0 1